import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { LoadIdView } from '../../../../models/shipment-id-view.model';
import { API_URL } from '../../../../../services/config';
import { ShipmentLoadEndpoint } from '../../constants/shipment-load-endpoint';
import { Observable } from 'rxjs';
import { getQueryStringFromObject } from '../../../../../common/utils';
import { ShipmentLoadDemurrageAndDetention } from '../../models/shipment-load-demurrage-and-detention.model';

@Injectable({ providedIn: 'root' })
export class ShipmentLoadDemurrageAndDetentionInfoService {
  constructor(private http: WrapperHttpService) {}

  getInfoData(loadIdView: LoadIdView): Observable<ShipmentLoadDemurrageAndDetention> {
    return this.http
      .withLoading()
      .get<ShipmentLoadDemurrageAndDetention>(
        `${API_URL}${ShipmentLoadEndpoint.Base}${ShipmentLoadEndpoint.Loads}${
          ShipmentLoadEndpoint.ContainerCharges
        }?${getQueryStringFromObject(loadIdView)}`,
      );
  }
}
